// copied over from schoolAnalyticsService

// https://github.com/SenecaLabs/schoolAnalyticsService/blob/main/packages/service/src/endpoints/reports/jobs/updateCourseTagEntities/consts.ts
export enum SubjectGB {
  agriculture = "Agriculture",
  ancientHistory = "Ancient History",
  ancientLanguages = "Ancient languages",
  archeology = "Archeology",
  artAndDesign = "Art & Design",
  astronomy = "Astronomy",
  biology = "Biology",
  business = "Business",
  chemistry = "Chemistry",
  childCare = "Childcare",
  citizenship = "Citizenship",
  classicalCivilisation = "Classical Civilisation",
  coding = "Coding",
  combinedScience = "Combined Science",
  computerScience = "Computer Science",
  construction = "Construction",
  designTechnology = "Design Technology",
  dance = "Dance",
  digital = "Digital",
  drama = "Drama",
  economics = "Economics",
  education = "Education",
  electronics = "Electronics",
  engineering = "Engineering",
  environmentalScience = "Environmental Science",
  english = "English",
  englishLanguage = "English Language",
  englishLiterature = "English Literature",
  englishLiteratureQuotations = "English Literature - Quotations",
  film = "Film",
  foodPreparationAndNutrition = "Food Preparation & Nutrition",
  french = "French",
  functionalSkills = "Functional Skills",
  geography = "Geography",
  geology = "Geology",
  german = "German",
  hairAndBeauty = "Hair & Beauty",
  healthAndSocialCare = "Health & Social Care",
  history = "History",
  hospitality = "Hospitality",
  law = "Law",
  maths = "Maths",
  mediaStudies = "Media Studies",
  music = "Music",
  nonVerbalReasoning = "Non-Verbal Reasoning",
  philosophy = "Philosophy",
  physicalEducation = "Physical Education",
  physics = "Physics",
  politics = "Politics",
  politicalStudies = "Political Studies",
  psychology = "Psychology",
  pshe = "PSHE",
  religiousStudies = "Religious Studies",
  science = "Science",
  sciencePracticals = "Science Practicals",
  sociology = "Sociology",
  statistics = "Statistics",
  spanish = "Spanish",
  verbalReasoning = "Verbal Reasoning"
}

// TODO: Assign department and add icon map for these
export enum SubjectDE {
  biologie = "Biologie",
  lehrkrafteFortbildung = "Lehrkräfte-Fortbildung",
  mathematic = "Mathematik",
  chemie = "Chemie",
  naturUndTechnik = "Natur und Technik",
  spanisch = "Spanisch",
  bnt = "Biologie, Naturphänomene & Technik",
  deutsch = "Deutsch",
  physik = "Physik",
  franzosisch = "Französisch",
  digitaleBildung = "Digitale Bildung",
  naturwissenschaften = "Naturwissenschaften",
  englisch = "Englisch",
  latein = "Latein"
}

const SubjectsGB = Object.values(SubjectGB);

export function isSubject(subject: string): subject is SubjectGB {
  return SubjectsGB.includes(subject as any);
}

export enum Department {
  business = "Business",
  computerScience = "Computer Science",
  designTechnology = "Design & Technology",
  drama = "Drama",
  economics = "Economics",
  english = "English",
  foodPrep = "Food Prep",
  geography = "Geography",
  history = "History",
  maths = "Maths",
  mediaStudies = "Media Studies",
  mfl = "MFL",
  music = "Music",
  pe = "PE",
  politics = "Politics",
  religiousStudies = "Religious Studies",
  science = "Science",
  socialScience = "Social Science",
  vocational = "Vocational",
  personalDevelopment = "Personal Development"
}

const Departments = Object.values(Department);

export function isDepartment(department: string): department is Department {
  return Departments.includes(department as Department);
}

type DepartmentSubjectsMap = {
  [department in Department]: (SubjectGB | SubjectDE)[];
};

export const departmentSubjectsMap: DepartmentSubjectsMap = {
  [Department.business]: [SubjectGB.business],
  [Department.computerScience]: [
    SubjectGB.computerScience,
    SubjectGB.coding,
    SubjectGB.designTechnology,
    SubjectGB.digital,
    SubjectGB.electronics,
    SubjectGB.mediaStudies
  ],
  [Department.designTechnology]: [SubjectGB.designTechnology],
  [Department.drama]: [SubjectGB.drama],
  [Department.economics]: [SubjectGB.economics],
  [Department.english]: [
    SubjectGB.english,
    SubjectGB.englishLanguage,
    SubjectGB.englishLiterature,
    SubjectGB.englishLiteratureQuotations
  ],
  [Department.foodPrep]: [SubjectGB.foodPreparationAndNutrition],
  [Department.geography]: [
    SubjectGB.geography,
    SubjectGB.geology,
    SubjectGB.environmentalScience
  ],
  [Department.history]: [
    SubjectGB.history,
    SubjectGB.classicalCivilisation,
    SubjectGB.ancientHistory,
    SubjectGB.ancientLanguages,
    SubjectGB.archeology,
    SubjectGB.history
  ],
  [Department.maths]: [SubjectGB.maths, SubjectGB.maths, SubjectGB.engineering],
  [Department.mediaStudies]: [SubjectGB.mediaStudies],
  [Department.mfl]: [SubjectGB.french, SubjectGB.german, SubjectGB.spanish],
  [Department.music]: [
    SubjectGB.music,
    SubjectGB.artAndDesign,
    SubjectGB.film,
    SubjectGB.dance
  ],
  [Department.pe]: [SubjectGB.physicalEducation],
  [Department.politics]: [
    SubjectGB.politicalStudies,
    SubjectGB.law,
    SubjectGB.politics
  ],
  [Department.religiousStudies]: [SubjectGB.religiousStudies],
  [Department.science]: [
    SubjectGB.astronomy,
    SubjectGB.biology,
    SubjectGB.chemistry,
    SubjectGB.combinedScience,
    SubjectGB.physics,
    SubjectGB.science,
    SubjectGB.sciencePracticals
  ],
  [Department.socialScience]: [
    SubjectGB.sociology,
    SubjectGB.psychology,
    SubjectGB.pshe,
    SubjectGB.philosophy,
    SubjectGB.religiousStudies,
    SubjectGB.healthAndSocialCare,
    SubjectGB.citizenship
  ],
  [Department.vocational]: [
    SubjectGB.education,
    SubjectGB.agriculture,
    SubjectGB.childCare,
    SubjectGB.construction,
    SubjectGB.foodPreparationAndNutrition,
    SubjectGB.hospitality,
    SubjectGB.hairAndBeauty
  ],
  [Department.personalDevelopment]: [
    SubjectGB.verbalReasoning,
    SubjectGB.functionalSkills,
    SubjectGB.nonVerbalReasoning
  ]
};

const DepartmentSubjectsEntries = Object.entries(departmentSubjectsMap) as [
  Department,
  SubjectGB[]
][];

export function getSubjectDepartment(
  subject: SubjectGB
): Department | undefined {
  return DepartmentSubjectsEntries.find(([_, subjects]) =>
    subjects.includes(subject)
  )?.[0];
}

export enum AgeGroupGB {
  GCSE = "GCSE",
  A_LEVEL = "A Level",
  KS3 = "KS3",
  PRIMARY = "Primary"
}
